import { render, staticRenderFns } from "./updaterequests.vue?vue&type=template&id=ab44fccc&scoped=true"
import script from "./updaterequests.vue?vue&type=script&lang=js"
export * from "./updaterequests.vue?vue&type=script&lang=js"
import style0 from "./updaterequests.vue?vue&type=style&index=0&id=ab44fccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab44fccc",
  null
  
)

export default component.exports